import { Link } from "react-router-dom";
import Layout from "@/components/app/Layout";
import { CATEGORIES } from "@/lib/categories";

export default function Categories() {
  return (
    <Layout>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="meta-label mb-2">Browse by discipline</div>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight">Categories</h1>
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {CATEGORIES.map((c) => (
            <Link
              key={c.id}
              to={`/explore?category=${c.id}`}
              className="group relative aspect-[4/3] rounded-lg overflow-hidden bg-muted"
              data-testid={`cat-${c.id}`}
            >
              <img src={c.image} alt={c.name} className="w-full h-full object-cover image-zoom" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-6">
                <div className="meta-label text-white/70 mb-1">Discipline</div>
                <div className="font-display text-white font-bold text-2xl sm:text-3xl">{c.name}</div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </Layout>
  );
}
